<template>
  <!-- 专业类别设置 -->
    <operateButton @btn-handle="btnHandle" @btn-in-table="btnInTable"
        :style="btnLeftList.length > 0 ? '' : 'display:block;'" @btn-on-left="btnOnList" />
  <el-button-group v-if="false">
    <el-button type="primary" size="large" @click="addFnc($event)"
    >
      <el-icon>
        <Plus/>
      </el-icon>
      添加专业类别
    </el-button
    >
  </el-button-group>

  <!-- 表格组件 -->
  <TableList
      componentTableId="MajorCategory"
      @update-list="updateList"
      excelName="专业类别设置"
      :table-data="tableData"
      :header-data="headerData"
      :table-height="
        btnLeftList.length > 0 ? tableMaxHeight : tableMaxHeight + 40
      "
      :loading="loading"
      :loading-text="loadingText"
      :empty-text="emptyText"
      @editFnc="editFnc"
      @deleteFnc="deleteFnc"
      :selectOptions="isPtzsbList"
      @searchFnc="searchFnc"
      @handleSelection="handleSelection"
  >
     <!-- 列表按钮操作动态 -->
      <template #inTableCustom="scope">
        <div class="optionDiv" style="white-space: nowrap; display: inline-block; float: left">
          <el-button-group style="display: flex" v-if="buttonList && buttonList.length > 1">
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </el-button-group>
          <div v-else>
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </div>
        </div>
      </template>
  <!-- <template #operationCustom="scope">
      <el-button type="primary" @click="editFnc(scope.scope)" plain>编辑</el-button>
      <el-button type="danger" @click="deleteFnc(scope.scope)" plain v-if="isDelect">删除</el-button>
    </template> -->
  </TableList>
  <!-- 底部工具 -->
  <Pagination
      :pagination="pagination"
      :is-loading="loading"
      @change-pagination="changePagination"
  >
  </Pagination>
  <!-- 添加编辑 专业类别设置 -->
  <el-dialog
      class="dialogNoPadding"
      :before-close="handleClose"
      :close-on-click-modal="false"
      v-model="addEditVisible"
      :title="dialogTitle"
      width="640px"
       draggable
            destroy-on-close
  >
    <AddEditMajorCategory
        ref="AddEditComponent"
        v-if="addEditVisible"
        :edit-id="editId"
        @close-dialog="closeDialog"
        @update-list="updateList"
    ></AddEditMajorCategory>
  </el-dialog>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue";
import Pagination from "components/Pagination.vue";
import {reactive, onMounted, toRefs, toRaw, ref,h,computed,nextTick } from "vue";
import store from "../../store/index";
import {ElMessage, ElMessageBox} from "element-plus";
import {lostFocus} from "common/utils";
import {
  getMajorCategoryList,
  delMajorCategory,
} from "network/majorCategory.js";
import AddEditMajorCategory from "views/majorCategory/AddEditMajorCategory.vue";

export default {
  name: "MajorCategory",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    Pagination,
    TableList,
    AddEditMajorCategory,
  },
  setup() {
    //这里定义一个结构体，用来保存页面数据
    const data = reactive({
      isDelect: computed(() => {
        return (
          store.state.isDelect ||
          JSON.parse(sessionStorage.getItem("isDelect"))
        );
      }),
      roleId:computed(() => store.state.AdminCache.roleId || sessionStorage.getItem("AdminCache").roleId),
      configRoleId:computed(() => store.state.AdminCache.configRoleId || sessionStorage.getItem("AdminCache").configRoleId),
      // 表格是否在加载中
      loading: true,
      multipleSelection:[],
      loadingText: "加载中...",
      emptyText: "暂无数据",
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      tableData: [], //表格数据
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        }, {
          label: "类别名称",
          prop: "name",
          width: "300",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
        },
        {
          label: "类别图片",
          prop: "imgUrl",
          minwidth: "200",
          align: "center",
          noSetText: "未设置",
          isImg: true,
        },
        {
          label: "是否普通专升本专业类别",
          prop: "isPtzsb",
          minwidth: "200",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
          isTag: true,
          isPtzsb: -1,
          zwidth:250
        },
      ],
      search: {
        //筛选项目
        name: null,
        isPtzsb: null,
      },
      isPtzsbList: [
        {key: -1, value: "是否普通专升本专业类别(全部)"},
        {key: 0, value: "否"},
        {key: 1, value: "是"},
      ],
      dialogTitle: "添加专业类别",
      addEditVisible: false,
      editId: 0,
    });

    //挂载后调用函数获取项目数据
    onMounted(() => {
      data.headerData.map((item) => {
        if (item.prop == "isPtzsb") {
          item.selectOptions = data.isPtzsbList;
        }
      });
      // 获取专业类别列表
      updateList();
    });

    // 请求专业类别列表
    const getListData = (val) => {
      data.loading = true;
      const obj = {
        name: data.search.name,
        isPtzsb: data.search.isPtzsb || data.search.isPtzsb === 0 ? data.search.isPtzsb : -1,
        pageIndex: data.pagination.currentPage,
        pageSize: data.pagination.pageSize,
      };
      getMajorCategoryList(obj)
          .then((result) => {
            if (result && result.code == 1) {
              data.loading = false;
              data.tableData = result.data;
              data.pagination.total = result.totalCount;
            } else {
              data.loading = false;
              ElMessage.error(result.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
    };

    // 搜索
    const searchFnc = (val) => {
      if (val.prop && val.prop == "name") {
        data.search.name = val.value;
      }
      if (val.prop && val.prop == "isPtzsb") {
        console.log(val);
        data.search.isPtzsb = val.value;
      }
      data.pagination.currentPage = 1;
      getListData();
    };

    //更新列表
    const updateList = () => {
      getListData();
    };

    //添加
    const addFnc = () => {
      // 强制移除按钮焦点
      data.addEditVisible = true;
      data.dialogTitle = "添加专业类别";
      data.editId = 0;
    };

    // 编辑
    const editFnc = (obj) => {
      data.addEditVisible = true;
      data.dialogTitle = `编辑【${data.multipleSelection[0].name}专业类别`;
      data.editId = data.multipleSelection[0].id;
    };

    //删除操作
    const deleteFnc = (obj) => {
         ElMessageBox({
        title: "删除",
        message: h("p", null, [
          h("span", null, "是否删除【"),
          h(
            "b",
            { style: "color: #fd5252;font-size:16px;" },
            `${data.multipleSelection[0].name}`
          ),
          h("span", null, "】专业类别？ "),
        ]),
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确认",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonLoading = true
            instance.confirmButtonText = "确认中"
            // 删除接口
            delMajorCategory(data.multipleSelection[0].id)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                ElMessage.success(result.message);
                updateList();
              } else {
                done();
                ElMessage.error(result.message);
              }
            })
            .catch((err) => {
              done();
              ElMessage.error(err.message);
            })
          } else {
            done();
          }
        },
      })
          
      .catch(() => {
        ElMessage("取消删除");
      });
    };

    function deleteCategory(id) {
      delMajorCategory(id)
          .then((result) => {

            if (result && result.code == 1) {
              ElMessage.success(result.message);
              updateList();
            } else {
              ElMessage.error(result.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
    }

    //关闭弹窗
    const closeDialog = () => {
      data.addEditVisible = false;
    };

    // 分页
    const changePagination = (val) => {
      data.pagination = toRaw(val);
      updateList();
    };

    //关闭添加编辑弹窗操作
    const AddEditComponent = ref();
    const handleClose = () => {
      if (data.addEditVisible) {
        AddEditComponent.value.resetForm();
        data.addEditVisible = false;
      }
    };
// 表格多选行处理
const handleSelection = (row) => {
  data.multipleSelection = JSON.parse(JSON.stringify(row));
};
const doEvent = function (btn, row) {
  try {
    data.multipleSelection = [];
    data.multipleSelection.push(row);
    eval(btn.split("(")[0] + `()`);
  }
  catch (err) {
    console.log(err);
    
    ElMessageBox.alert("err");
  }
}
    const btnHandle = (val) => {
      try {
        eval(val);
      } catch (error) {
        ElMessage.error("按钮事件不存在");
      }
    };
    const btnLeftList = ref([]);
    const buttonList = ref([]);
    const btnOnList = (val) => {
      btnLeftList.value = val ? val : [];
    }
    const btnInTable = async (val) => {
      if (val?.length > 0) {
        // 先设置按钮数据并插入列定义
        buttonList.value = val;
        data.headerData.splice(1, 0, {
          label: "操作",
          prop: "inTable",
          align: "center",
          fixed: "left",
          custom: true,
          isInTable: true,
        });
        // 等待 DOM 更新，确保表格单元格渲染完毕以便正确测量宽度
        await nextTick();
        await nextTick();
        // 获取操作按钮组的元素并测量宽度
        const opts = document.getElementsByClassName("optionDiv");
        let widthArr = [];
        Array.prototype.forEach.call(opts, function (item) {
          if (item.offsetWidth > 0) {
            widthArr.push(item.offsetWidth);
          }
        });
        if (widthArr.length > 0 && buttonList.value?.length > 0) {
          let index = 0;
          var obj = {};
          for (var i = 0; i < data.headerData.length; i++) {
            if (data.headerData[i].label == "操作") {
              index = i;
              obj = JSON.parse(JSON.stringify(data.headerData[i]));
              // 使用数字类型宽度（px由组件处理），并留出一定内边距
              obj.width = Math.max(...widthArr) + 24;
            }
          }
          data.headerData[index] = obj;
        }
      }
    };
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      updateList,
      getListData,
      searchFnc,
      addFnc,
      editFnc,
      deleteFnc,
      closeDialog,
      changePagination,
      AddEditComponent,
      handleClose,
      handleSelection,
      btnInTable,
      btnLeftList,
      buttonList,
      btnOnList,
      btnHandle,
      doEvent,
    };
  },
};
</script>

<style scoped>
</style>